angular.module('igs.apiClientService', ['igs.waitMask', 'igs.errorHandlerService', 'igs.identity'])
    .factory('igs.apiClientService', [
        '$http',
        '$q',
        'igs.maskingService',
        'igs.errorHandlerService',
        '$location',
        '$window',
        function($http, $q, maskingService, errorHandler, $location, $window) {
            'use strict';
            var service = {};

            function getObjectWithCamelCaseProperties(obj) {
                if (_.isPlainObject(obj) || _.isArray(obj)) {
                    var mappedObject = _.isArray(obj) ? [] : {};

                    _.forOwn(obj, function(val, key) {
                        mappedObject[_.camelCase(key)] = getObjectWithCamelCaseProperties(val);
                    });

                    return mappedObject;
                } else {
                    return obj;
                }
            }

            function getObjectWithDeCamelCaseProperties(obj) {
                if (_.isPlainObject(obj) || _.isArray(obj)) {
                    var mappedObject = _.isArray(obj) ? [] : {};

                    _.forOwn(obj, function (val, key) {
                        mappedObject[capitalizeFirstLetter(key)] = getObjectWithDeCamelCaseProperties(val);
                    });

                    return mappedObject;
                } else {
                    return obj;
                }
            }

            function capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }

            function createResponseDataGetter(config) {
                return _.partialRight(getResponseData, config);
            }

            function getResponseData(response, config) {
                if (config && config.toCamelCase) {
                    return getObjectWithCamelCaseProperties(response.data);
                }

                if (config && config.toDeCamelCase) {
                    return getObjectWithDeCamelCaseProperties(response.data);
                }

                return response.data;
            }

            function buildUrl(url) {
                if (!url.startsWith("/"))
                    url = `/${url}`;

                if (!url.toLowerCase().startsWith("/api"))
                    url = `/api${url}`;

                if (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf('bs-local.com') > 0)
                    url = `/IGS.Solar.Web${url}`;

                return url;
            }

            function massageConfig(config) {
                var c = config || {};

                const isAutomation = window.sessionStorage.getItem('automation');
                if (isAutomation) {
                    c.headers = c.headers || {};
                    c.headers.IsAutomation = true;
                }
                
                return c;
            }
            
            service.getCacheConfig = function(config) {
                var c = config || {};
                c.cache = true;
                return c;
            };

            service.getNoMaskConfig = function(config) {
                var c = config || {};
                c.nomask = true;
                return c;
            };

            service.getUnsecure = function(url, config) {
                config = massageConfig(config);
                if (config && config.nomask) {
                    return $http.get(buildUrl(url), config).then(createResponseDataGetter(config), createErrorHandler(config));
                } else {
                    return maskingService.maskPromise($http.get(url, config).then(createResponseDataGetter(config), createErrorHandler(config)));
                }
            };

            service.postUnsecure = function(url, data, config) {
                config = massageConfig(config);
                data = data || {};
                
                if (config && config.nomask) {
                    return $http.post(buildUrl(url), data, config).then(createResponseDataGetter(config), function(error) { return $q.reject(error); });
                } else {
                    return maskingService.maskPromise($http.post(url, data, config).then(createResponseDataGetter(config), createErrorHandler(config)));
                }
            };

            service.get = function(url, config) {
                config = massageConfig(config);
                
                var call = function() {
                    return $http.get(buildUrl(url), config).then(createResponseDataGetter(config), createErrorHandler(config));
                };

                if (!config.nomask) {
                    return maskingService.maskPromise(call());
                }

                return call();
            };

            service.post = function (url, data, config) {
                data = data || {};
                config = massageConfig(config);
                
                var call = function() {
                    return $http.post(buildUrl(url), data, config).then(createResponseDataGetter(config), createErrorHandler(config));
                };

                if (!config || !config.nomask) {
                    return maskingService.maskPromise(call());
                }

                return call();
            };

            service.put = function (url, data, config) {
                data = data || {};
                config = massageConfig(config);
              
                var call = function() {
                    return $http.put(buildUrl(url), data, config).then(createResponseDataGetter(config), createErrorHandler(config));
                };

                if (!config || !config.nomask) {
                    return maskingService.maskPromise(call());
                }

                return call();
            };

            var createErrorHandler = function(config) {
                config = config || {};
                var determinedErrorHandler = (config.errorHandler) || errorHandler.getErrorHandler(null, null);
                
                return function (error) {
                    switch (error.status) {
                    case 0:
                        error.data = 'No Internet Connection, Please Try Again';
                        determinedErrorHandler(error);
                        break;
                    case 401:
                        $window.location.href =
                            $location.absUrl().toLowerCase().indexOf('http://localhost/igs.solar.web') >= 0
                                ? '/igs.solar.web/#/login'
                                : '/#/login';

                        break;
                    case 403:
                        $window.location.href =
                            $location.absUrl().toLowerCase().indexOf('http://localhost/igs.solar.web') >= 0
                            ? '/igs.solar.web/#/login'
                            : '/#/login';

                        break;
                    default:
                        determinedErrorHandler(error);
                    }

                    return $q.reject(error);
                }
            };

            service.generateQueryStringUrl = function(url, params) {
                if (!_.isString(url)) {
                    _.igs.throwError('URL is required');
                }

                url = _.reduce(params, function(result, val, key) {
                    return _.isString(val) || _.isNumber(val) ?
                               result + key + '=' + val + '&' :
                               result;
                }, url + '?');

                return encodeURI(url);
            };

            service.downloadFile = function(url, data, method) {
                if (url && data) {
                    var inputs = '';
                    var convertToInput = function(key, keyStr, obj) {
                        if (typeof obj === 'undefined') {
                            return;
                        } else if (Object.prototype.toString.call(obj) === '[object Date]') {
                            inputs += "<input type='hidden' name='" + keyStr + "' value='" + obj.toUTCString() + "' />";
                            return;
                        } else if (typeof obj === "object") {
                            for (var innerKey in obj) {
                                if (obj.hasOwnProperty(innerKey)) {
                                    var innerKeyStr = '';
                                    if (keyStr === '') {
                                        innerKeyStr = innerKey.toString();
                                    } else {
                                        innerKeyStr = keyStr + "[" + innerKey.toString() + "]";
                                    }
                                    convertToInput(innerKey, innerKeyStr, obj[innerKey]);
                                }
                            }
                            return;
                        } else if ($.isArray(obj)) {
                            obj.forEach(function(item) {
                                convertToInput(key, keyStr + "[]", item);
                            });
                            return;
                        }
                        inputs += "<input type='hidden' name='" + keyStr + "' value='" + obj + "' />";
                    };
                    convertToInput(null, '', data);
                    jQuery('<form action="' + url + '" method="' + (method || 'post') + '">' + inputs + '</form>').appendTo('body').submit().remove();
                };
            };
            return service;
        }

    ]);